<template>
  <div>
    <el-tabs type="card" @tab-click="gotoRoue(tab,$event)" v-model="currentIndex">
      <el-tab-pane
        v-for="(item,index) in topnavlist"
        :label="item.name"
        :key="index"
        :path="item.path"
        :ref="item.name"
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  props: {
    topnavlist: {
      type: Array,
      default: () => {
        return [];
      }
    },
    currentTab: {
      type: String,
      default: () => {
        return "基础信息";
      }
    }
  },
  data() {
    return {
      currentIndex: this.currentTab
    };
  },
  methods: {
    gotoRoue(tab, i) {
      console.log("tab", tab)
      console.log("i", i)
      this.$router.push(i.path);
      this.$emit("fatherFunc", i.name);
    }
  }
};
</script>
<style>
.el-tabs--border-card > .el-tabs__content {
  padding: 0px;
}

.el-tabs__header {
  margin: 0px;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #409eff;
  color: white;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom: none;
}
</style>

<style lang="scss" scoped>
</style>

